import React from "react";
import {
    Link
} from "react-router-dom";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import ReactPlayer from "react-player";

import VideoPlayer from "../../../../../components/VideoPlayer";

function parseLink({ node, href, children, ...linkProps }) {
    const currentUrl = new URL(window.location.href);
    const url = new URL(href);

    if(ReactPlayer.canPlay(href)) {
        return (
            <VideoPlayer url={ href }/>
        )
    }
    const localUrl = currentUrl.protocol === url.protocol && currentUrl.hostname === url.hostname;
    if(localUrl) {
        return (
            <Link to={ url.pathname }>
                { children }
            </Link>
        )
    }
    return (
        <a
            href={ href }
            target="_blank"
            rel="noopener noreferrer"
            { ...linkProps }
        >
            { children }
        </a>
    )
}

function CourseMarkdown({ children }) {
    return (
        <ReactMarkdown
            remarkPlugins={[gfm]}
            components={{
                a: parseLink
            }}
        >
            { children }
        </ReactMarkdown>
    )
}

export default React.memo(CourseMarkdown);
